import { useEffect } from 'react';

/**
 * Custom hook to handle scroll reveal animations.
 * It uses IntersectionObserver to add the 'active' class to elements with 
 * 'reveal', 'reveal-left', or 'reveal-right' classes when they enter the viewport.
 */
const useReveal = () => {
    useEffect(() => {
        const reveal = () => {
            const reveals = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');

            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('active');
                        // Once revealed, we can stop observing this element
                        observer.unobserve(entry.target);
                    }
                });
            }, {
                threshold: 0.15, // Trigger when 15% of the element is visible
                rootMargin: '0px 0px -50px 0px' // Trigger slightly before it hits the bottom
            });

            reveals.forEach((el) => observer.observe(el));
        };

        reveal();
    }, []);
};

export default useReveal;
